import { all, call } from 'redux-saga/effects';
import parent from './parent/parentSagas';

export default function* saga() {
	yield all([call(parent)]);
}
